enum AccessReportTypeEnum {
  Unknown = "Unknown",
  Advanced = "Advanced",
  Standard = "Standard",
}

export { AccessReportTypeEnum };
